import {baseInstance} from './baseInstance';

export const usersApi = {
        getAll: () => baseInstance.get(`/users`),
}